import confetti from 'canvas-confetti';

function prefersReducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function getThemeColors() {
  if (typeof window === 'undefined' || !window.getComputedStyle) {
    return ['#d32f2f', '#ff5722', '#ffa000'];
  }
  const cs = window.getComputedStyle(document.documentElement);
  const primary = (cs.getPropertyValue('--primary-color') || '#d32f2f').trim();
  const accent = (cs.getPropertyValue('--accent-color') || '#ff5722').trim();
  const secondary = (cs.getPropertyValue('--secondary-color') || '#ffa000').trim();
  return [primary, accent, secondary, '#ffffff'];
}

/**
 * Party bomb / confetti burst.
 * 
 * Uses theme colors and avoids excessive animation if user prefers reduced motion.
 */
export function partyBomb(opts = {}) {
  if (prefersReducedMotion()) return;

  const colors = getThemeColors();
  const particleCount = opts.particleCount ?? 120;

  const defaults = {
    origin: { y: 0.65 },
    spread: 80,
    ticks: 120,
    gravity: 1.1,
    decay: 0.92,
    startVelocity: 34,
    scalar: 1,
    colors,
  };

  const fire = (ratio, extra) =>
    confetti({
      ...defaults,
      ...extra,
      particleCount: Math.floor(particleCount * ratio),
    });

  // Two side pops + one center burst ("party bomb" feel)
  fire(0.35, { spread: 65, origin: { x: 0.2, y: 0.75 } });
  fire(0.35, { spread: 65, origin: { x: 0.8, y: 0.75 } });
  fire(0.45, { spread: 110, startVelocity: 42, origin: { x: 0.5, y: 0.55 } });

  // A small sparkle follow-up
  setTimeout(() => {
    fire(0.18, { spread: 120, startVelocity: 28, scalar: 0.9, origin: { x: 0.5, y: 0.6 } });
  }, 180);
}

export default partyBomb;
